/* styled-components & other non-external style-related exports (like, say, a `headerHeight` var) go here */
import { zindex, font, colors, spacing, breakpoints, FadeInAnimation, SlideInAnimation, FadeOutAnimation, SlideOutAnimation, ReduceMotion, animationDurationInMS } from '@chegg-ui/theme';
import { IconButton } from '@chegg-ui/button';
import styled, { css } from 'styled-components';
export var FullsizeContainer = styled.div.withConfig({
  componentId: "sc-1ia47o9-0"
})(["position:fixed;top:0;left:0;right:0;bottom:0;z-index:", ";background-color:", ";"], zindex.modal, function (props) {
  return props.hideBackgroundOverlay ? 'transparent' : 'rgba(0,0,0,0.5)';
}); // this is unfortunately necessary to work around this bug: https://bugs.chromium.org/p/chromium/issues/detail?id=521364

export var ModalCenteringContainer = styled.div.withConfig({
  componentId: "sc-1ia47o9-1"
})(["animation:", ";", " padding:1rem;box-sizing:border-box;height:100%;display:grid;grid-gap:1rem;grid-template-columns:repeat(4,[col-start] 1fr);-ms-grid-columns:[col-start] 1rem 1fr 1rem [col-start] 1rem 1fr 1rem [col-start] 1rem 1fr 1rem [col-start] 1rem 1fr;@media only screen and (max-width:", "){padding:0;}@media only screen and (min-width:", ") and (max-width:", "){grid-template-columns:repeat(8,[col-start] 1fr);-ms-grid-columns:[col-start] 1rem 1fr 1rem [col-start] 1rem 1fr 1rem [col-start] 1rem 1fr 1rem [col-start] 1rem 1fr 1rem [col-start] 1rem 1fr 1rem [col-start] 1rem 1fr 1rem [col-start] 1rem 1fr 1rem [col-start] 1rem 1fr;}@media only screen and (min-width:", "){grid-template-columns:repeat(12,[col-start] 1fr);-ms-grid-columns:[col-start] 1rem 1fr 1rem [col-start] 1rem 1fr 1rem [col-start] 1rem 1fr 1rem [col-start] 1rem 1fr 1rem [col-start] 1rem 1fr 1rem [col-start] 1rem 1fr 1rem [col-start] 1rem 1fr 1rem [col-start] 1rem 1fr 1rem [col-start] 1rem 1fr 1rem [col-start] 1rem 1fr 1rem [col-start] 1rem 1fr 1rem [col-start] 1rem 1fr;}"], function (props) {
  return props.closing ? css(["", ",", ""], FadeOutAnimation({
    delay: 100
  }), SlideOutAnimation({
    toX: '0',
    toY: '20px',
    duration: animationDurationInMS.medium
  })) : css(["", ",", ""], FadeInAnimation(), SlideInAnimation({
    fromX: '0',
    fromY: '20px',
    duration: animationDurationInMS.medium
  }));
}, ReduceMotion, breakpoints.sm.max, breakpoints.md.min, breakpoints.md.max, breakpoints.lg.min);
export var Title = styled.h2.withConfig({
  componentId: "sc-1ia47o9-2"
})(["animation:", ";", " display:block;margin:0 0 ", " 0;color:", ";font-family:", ";font-weight:", ";font-size:", ";line-height:", ";text-align:inherit;"], function (props) {
  return props.closing ? css(["", ",", ""], FadeOutAnimation({
    delay: 100
  }), SlideOutAnimation({
    toX: '0',
    toY: '10px',
    delay: 100
  })) : css(["", ",", ""], FadeInAnimation({
    delay: 100,
    fillMode: 'backwards'
  }), SlideInAnimation({
    fromX: '0',
    fromY: '10px',
    delay: 100
  }));
}, ReduceMotion, spacing.px24, colors.dark, font.family["default"], font.weight.bold, font.size.px32, font.lineHeight.sm);
export var Content = styled.div.withConfig({
  componentId: "sc-1ia47o9-3"
})(["animation:", ";", " word-wrap:break-word;overflow-y:auto;overflow-x:hidden;line-height:", ";"], function (props) {
  return props.closing ? css(["", ",", ""], FadeOutAnimation({
    duration: animationDurationInMS.fastest,
    delay: 100
  }), SlideOutAnimation({
    toX: '0',
    toY: '10px',
    duration: animationDurationInMS.fastest,
    delay: 100
  })) : css(["", ",", ""], FadeInAnimation({
    delay: 100,
    fillMode: 'backwards'
  }), SlideInAnimation({
    fromX: '0',
    fromY: '10px',
    delay: 100
  }));
}, ReduceMotion, font.lineHeight.lg);
export var StyledModal = styled.div.withConfig({
  componentId: "sc-1ia47o9-4"
})(["background-color:", ";font-family:", ";font-size:", ";display:flex;flex-direction:column;position:relative;box-sizing:border-box;max-width:100%;max-height:100%;min-height:0;margin:auto;width:100%;grid-column:col-start 1 / span 4;@media (max-width:", "){height:100%;}@media only screen and (min-width:", ") and (max-width:", "){grid-column:col-start 1 / span 8;}@media only screen and (min-width:", ") and (max-width:", "){grid-column:col-start 3 / span 8;}@media only screen and (min-width:", "){grid-column:col-start 4 / span 6;}"], colors.white, font.family["default"], font.size.px16, breakpoints.sm.max, breakpoints.md.min, breakpoints.md.max, breakpoints.lg.min, breakpoints.lg.max, breakpoints.xl.min);
export var ModalPadding = styled.div.withConfig({
  componentId: "sc-1ia47o9-5"
})(["flex:1;overflow-y:auto;padding:", " ", " ", " ", ";@media (max-width:", "){padding:", ";}"], spacing.px64, spacing.px64, spacing.px32, spacing.px64, breakpoints.sm.max, spacing.px32);
export var ConfirmationStyledModal = styled(StyledModal).withConfig({
  componentId: "sc-1ia47o9-6"
})(["& ", "{text-align:center;}& ", "{text-align:center;}@media (max-width:", "){width:calc(100% - 2 * ", ");margin:", ";}"], Content, Title, breakpoints.sm.max, spacing.px16, spacing.px16);
export var TopRightIconButton = styled(IconButton).withConfig({
  componentId: "sc-1ia47o9-7"
})(["position:absolute;top:", ";right:", ";@media (max-width:", "){top:0;right:0;}"], spacing.px8, spacing.px8, breakpoints.sm.max);
export var ButtonAnimationContainer = styled.div.withConfig({
  componentId: "sc-1ia47o9-8"
})(["display:flex;animation:", ";", ""], function (props) {
  return props.closing ? css(["", ",", ""], FadeOutAnimation({
    duration: animationDurationInMS.fastest
  }), SlideOutAnimation({
    toX: '0',
    toY: '10px',
    duration: animationDurationInMS.fastest
  })) : css(["", ",", ""], FadeInAnimation({
    delay: 200,
    fillMode: 'backwards'
  }), SlideInAnimation({
    fromX: '0',
    fromY: '10px',
    delay: 200
  }));
}, ReduceMotion);
export var ModalButtons = styled.div.withConfig({
  componentId: "sc-1ia47o9-9"
})(["display:inline-flex;flex-direction:", ";margin-top:", ";margin-left:auto;", ";"], function (_ref) {
  var alignment = _ref.alignment;
  return alignment === 'horizontal' ? 'row-reverse' : 'column';
}, spacing.px24, function (_ref2) {
  var alignment = _ref2.alignment;
  return alignment === 'horizontal' ? "& > button:first-child {\n      margin-left: ".concat(spacing.px16, ";\n    }") : "\n      margin-right: auto;\n      & > button:last-child {\n        margin-top: ".concat(spacing.px16, ";\n      }");
});
export var ConfirmationModalButtons = styled.div.withConfig({
  componentId: "sc-1ia47o9-10"
})(["display:inline-flex;flex-direction:", ";margin-left:auto;margin-right:auto;flex-wrap:wrap;justify-content:center;& > button{margin-top:", ";}", ";"], function (_ref3) {
  var alignment = _ref3.alignment;
  return alignment === 'horizontal' ? 'row-reverse' : 'column';
}, spacing.px16, function (_ref4) {
  var alignment = _ref4.alignment;
  return alignment === 'horizontal' ? "& > button:first-child {\n      margin-left: ".concat(spacing.px16, ";\n    }") : "\n      margin-right: auto;\n      & > button:last-child {\n        margin-top: ".concat(spacing.px16, ";\n      }");
});
export var PresentationContent = styled.div.withConfig({
  componentId: "sc-1ia47o9-11"
})(["max-width:10rem;max-height:10rem;text-align:center;margin:0 auto ", ";@media (max-width:", "){max-width:5.5rem;max-height:5.5rem;margin-bottom:", ";}& > img{max-width:10rem;max-height:10rem;@media (max-width:", "){max-width:5.5rem;max-height:5.5rem;}}"], spacing.px32, breakpoints.sm.max, spacing.px24, breakpoints.sm.max);